import React from 'react'
import { 
  Form, FormGroup, FormControl, ControlLabel
} from 'react-bootstrap'

import { getStatusValues, getStatusLabel } from '../TripStatus'
import { getText } from '../../lib/text.js'


/**
 * selector estado
 */
/* 
type TSProps = {
  status: number,
  onChange: number => void,
  style: Object,
  includeLabel: boolean,
  extraThin: boolean,
  shorter: boolean,
}
 */
const TripStatusSelect = ({ status, onChange, style, includeLabel, extraThin, shorter }/* : TSProps */) => (
  <div
    style={{ ...(extraThin ? {} : { marginBottom: 10, marginTop: 10 }), ...style }}
  >
    <Form inline>
      <FormGroup controlId="fg_trip_status">
        {
          includeLabel
            ? (<ControlLabel style={{ fontSize: 16, marginRight: 20 }}>{getText("Estado")} </ControlLabel>)
            : ""
        }
        <FormControl
          componentClass="select"
          placeholder="select"
          bsSize="small"
          style={{
            marginLeft:0,
            maxWidth: 150,
            ...(extraThin ? { height: 30, border: "none", background: "none", boxShadow: "none" } : {})
          }}
          value={status}
          onChange={evt => onChange(parseInt(evt.target.value))}
        >
          {
            getStatusValues().map(v => (
              <option key={v} value={v}>{getStatusLabel(v, { shorter })}</option>
            ))
          }
        </FormControl>
      </FormGroup>
    </Form>
  </div>
)

TripStatusSelect.defaultProps = {
  style: {},
  includeLabel: true,
  extraThin: false,
}

export default TripStatusSelect
